import { createBrowserPwaEnvironment } from "./browserEnvironment";
import { PwaController } from "./PwaController";
import { registerPwaServiceWorker } from "./registerServiceWorker";

export const pwaController = new PwaController({
  environment: createBrowserPwaEnvironment(),
  registerServiceWorker: registerPwaServiceWorker
});
